import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { ModuleEntity } from '../../../module/module.entity';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { MatLabel } from '@angular/material/form-field';

@Component({
  selector: 'pixl-module-form-dialog',
  templateUrl: './module-form-dialog.component.html',
  imports: [
    MatDialogContent,
    MatFormField,
    MatDialogTitle,
    MatLabel,
    MatFormField,
    MatInput,
    MatFormField,
    MatSelect,
    MatOption,
    MatDialogActions,
    ReactiveFormsModule,
    MatButton
  ],
  styleUrls: ['./module-form-dialog.component.scss']
})
export class ModuleFormDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModuleFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: Partial<ModuleEntity>
  ) {
    this.form = this.fb.group({
      title: [data?.title || '', Validators.required],
      status: [data?.status || 'Edit', Validators.required],
      description: [data?.description || ''],
      preTitle: [data?.preTitle || ''],
    });
  }

  save(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
